// Unsafely injects HTML to a given element
export const setDangerousHtml = html => el => {
  if (html && el) {
    const range = document.createRange();
    range.selectNodeContents(el);
    range.deleteContents();
    el.appendChild(range.createContextualFragment(html));
  }
};

export const insertHtmlToTag = (html, element, tag) => {
  if(!['body', 'head'].includes(tag)) return null;

  var temp = document.createElement(element)
  temp.innerHTML = html
  
  var isInserted = false;
  document.getElementsByTagName(tag)[0].childNodes.forEach((node) => {
    if(node.isEqualNode(temp)) isInserted = true;
  })
  !isInserted && document.getElementsByTagName(tag)[0].appendChild(temp);
}

export const setCustomHtml = (html, tag) => {
  if (!['body', 'head'].includes(tag)) return null;
  
  const fragment = document.createRange().createContextualFragment(html);
  const target = document[tag];
  
  if (!target) return null;
  
  target.appendChild(fragment);
};

// Parses an encoded/unsafe HTML string and returns a clean one
export const parseHtmlText = html => {
  const parser = new DOMParser();
  const dom = parser.parseFromString("<!doctype html><body>" + html, "text/html");

  return dom.body.textContent;
};


export const waitForElm = (selector) => {
  return new Promise(resolve => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver(() => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}

export const waitForMultiElm = selector => {
  return new Promise(resolve => {
    if (document.querySelectorAll(selector).length) {
      return resolve(document.querySelectorAll(selector));
    }
    const observer = new MutationObserver(() => {
      const res = document.querySelectorAll(selector);
      if (res.length) {
        resolve(document.querySelectorAll(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
};


export const insertCss = (code) => {
  const style = document.createElement('style');
  style.type = 'text/css';

  if (style.styleSheet) {
      // IE
      style.styleSheet.cssText = code;
  } else {
      // Other browsers
      style.innerHTML = code;
  }

  document.getElementsByTagName("head")[0].appendChild( style );
}